import { ConcessionCardTypeSchema } from '@montugroup/pms-api-contracts';
import { z } from 'zod';

export const schema = z.object({
  cardNumber: z.string().optional(),
  cardType: ConcessionCardTypeSchema.optional(),
  expiryDay: z.number().optional(),
  expiryMonth: z.number().optional(),
  expiryYear: z.number().optional(),
  hasValidConcessionCard: z.boolean().optional(),
  expiration: z.string().optional(),
  status: z.string().optional()
});

export type ConcessionCardFormFields = z.infer<typeof schema>;
